import axios from "axios";
import { API } from "../../../backend";
import authHeader from "../../auth-header"
const getPartyNotificationDetails = (state) => {
  
  return axios.get(API + "parties/edit-notification/"+state+"/",{headers: authHeader(),});
};
const editPartyNotificationDetails = (state, notification_reminder, notification_type,notification_days,to_email,enable) => {
    return axios.post(API + "parties/edit-notification/" +state+"/", {
        state,
        notification_reminder,
        notification_type,
        notification_days,
        to_email,
        enable
    },{headers: authHeader(),});
  };
const EditNotificationService = {
    getPartyNotificationDetails,
    editPartyNotificationDetails,
  };
  export default EditNotificationService;